import {SourceType} from '@types';

const strings = {
    search: 'Search',
    resource: 'RESOURCE',
    source: (source: string) => {
        if (SourceType.guard(source)) {
            switch (source as SourceType) {
                case 'community':
                    return 'Community';
                case 'documentation':
                    return 'Documentation';
                case 'partner_documentation':
                    return 'Partner Documentation';
                case 'knowledge_base':
                    return 'Knowledge Base';
                case 'release_notes':
                    return 'Release Notes';
                case 'drafts':
                    return 'Drafts';
            }
        }

        return 'Unknown';
    },
    loading: 'Loading...',
    showingResults: (pageRange: string, total: number, searchString: string) =>
        `Showing ${pageRange} of ${total} results for "${searchString}"`,
    likes: (count: number) => `${count || 0} Likes`,
    views: (count: number) => `${count || 0} Views`,
    supportContacts: 'Support Contacts',
    availability: 'Available 24/7, 365 days a year',
    tollFree: '(toll-free)',
    supportPhone: '+1 (650) 238-9361',
    email: 'support@brightpattern.com',
    openTicket: 'Open a Ticket',
    usPhone: '+1 (855) 545-5200',
};

export default strings;
